import Navbar from "../components/Navbar";

export default function AppLayout({ children, onLogout, isAdmin = false }) {
  return (
    <div>
      <Navbar onLogout={onLogout} isAdmin={isAdmin} />
      <div style={{ padding: 20 }}>
        {children}
      </div>
    </div>
  );
}
